<template>
  <div class="bj">
    <div class="phone_left">
      <div class="phone_left" v-if="tabledata">
        <div class="phone_left_div">
          <div class="top">
            <img class="wechatlogo" src="../../../../assets/wechatlogo.png" alt="">
            <div class="title">
              <div class="top_title">{{ tabledata.task_species_name }}</div>
              <div class="bot_title"><span v-if="!isStep">剩余{{ tabledata.left_amount }}份</span> 任务时长{{
                  tabledata.task_time == 1 ? '5分钟' : tabledata.task_time == 2 ? '15分钟' : tabledata.task_time == 3 ? '30分钟' : tabledata.task_time == 4 ? '60分钟' : '60分钟以上'
                }}
              </div>
            </div>
            <div class="price">{{ tabledata.price == '' ? 0 : (tabledata.price / 100) }}元</div>
          </div>
          <el-divider></el-divider>
          <el-row>
            <el-col :span="24">
              <p class="introduce">任务介绍</p>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <p class="introduce_text">
                {{ tabledata.task_desc }}
              </p>
            </el-col>
          </el-row>
          <el-divider></el-divider>
          <el-row>
            <el-col :span="24">
              <div class="introduce_line">
                <div class="line"></div>
                操作步骤
              </div>
            </el-col>
          </el-row>
          <template v-for="(item,index) in tabledata.task_step_guide_data">
            <el-row>
              <el-col :span="2">
                <div class="circular">
                  {{ index + 1 }}
                </div>
              </el-col>
              <el-col :span="22">
                <el-row>
                  <el-col style="margin-left: 20px" :span="24">
                    {{ item.desc }}
                  </el-col>
                  <el-col style="margin-left: 20px" :span="24">
                    <el-image
                        style="width: 88px; height: 88px;margin-right: 10px;margin-bottom: 10px"
                        v-for="(uri,idx) in item.images" :key="idx" :src="uri"
                        :preview-src-list="item.images">
                    </el-image>
                  </el-col>
                </el-row>
                <template v-for="(rule,ruleindex) in item.rules">
                  <el-row style="margin-bottom: 20px">
                    <el-col style="margin-left: 20px" :span="24">
                      {{ rule.text }}
                    </el-col>
                    <el-col style="margin-left: 20px;padding-right: 40px" :span="24" v-if="rule.type==1">
                      <el-input
                          placeholder="请输入内容"
                          :disabled="true">
                      </el-input>
                    </el-col>
                    <el-col style="margin-left: 20px;padding-right: 40px" :span="24" v-if="rule.type==2">
                      <el-image>
                        <div slot="error" class="image-slot">
                          <img src="../../../../assets/yulan.png" height="126" width="143"/>
                        </div>
                      </el-image>
                    </el-col>
                  </el-row>
                </template>

              </el-col>
            </el-row>
          </template>
          <el-divider></el-divider>
          <el-row>
            <el-col :span="24" style="text-align: center;margin-bottom: 20px">
              <el-button style="width: 88%" type="primary">领取任务</el-button>
            </el-col>
          </el-row>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from "@/api";

export default {
  name: "mobilePreview",
  props: {
    order_id: null,
    isStep: {
      type: Boolean,
      default: false
    },
    formData: {
      type: Object,
      default: () => {
      }
    }
  },
  data() {
    return {
      guide: [],
      tabledata: undefined
    };
  },
  watch: {
    order_id() {
      this.gettabdata();
    },
  },
  mounted() {
    if (this.isStep) {
      this.tabledata = {...this.formData};
      this.tabledata.task_step_guide_data = this.tabledata.task_step_guide;
      this.tabledata.price = this.tabledata.price * 100;
      console.log(this.tabledata, 11)
    } else {
      this.getData();
    }

  },
  methods: {
    getData() {
      this.gettabdata();
    },
    async gettabdata() {
      this.tabledata = await Api.post.getMoneytask({
        id: this.order_id
      });
      if (this.tabledata) {
        this.guide = this.tabledata.task_step_guide_data
      }
    },
  },
}
</script>

<style scoped lang="scss">
.bj {
  background: #F6F6F6;
  display: flex;
  flex-wrap: nowrap;
}

.phone_left {
  background: url("../../../../assets/phone.png") no-repeat center;
  background-size: 100% 100%;
  height: 765px;
  width: 375px;
  position: relative;
  margin: 0 auto;
}

.phone_left_div {
  width: 323px;
  height: 574px;
  position: absolute;
  left: 26px;
  top: 94px;
  overflow-y: scroll;
  overflow-x: hidden;
}

.top {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;

  .wechatlogo {
    width: 40px;
    height: 40px;
    margin: 20px 10px 0 20px;
  }

  .title {
    width: 180px;
    margin-top: 16px;

    .top_title {
      width: 100%;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 28px;
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
      line-height: 28px;
    }

    .bot_title {
      width: 100%;
      display: inline-block;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      height: 17px;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #666666;
      line-height: 17px;
    }
  }

  .price {
    font-size: 17px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #FC5646;
    line-height: 24px;
    margin-top: 20px;
  }
}

.introduce {
  height: 25px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 25px;
  margin-left: 40px;
}

.introduce_text {
  width: 88%;
  margin: 0 auto;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  line-height: 24px;
}

.introduce_line {
  width: 100%;
  height: 18px;
  font-size: 18px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: #333333;
  line-height: 18px;
  margin-bottom: 10px;

  .line {
    width: 4px;
    height: 18px;
    background: #1989FF;
    float: left;
    margin-left: 20px;
    margin-right: 14px;
  }
}

.circular {
  width: 24px;
  height: 24px;
  background: #94C8FF;
  border-radius: 50%;
  margin-left: 20px;
  text-align: center;
  line-height: 24px;
  font-weight: bold;
  color: #ffffff;
}
</style>
